/**
 * @file paddle 首页
 * @author wanzhongyun
 */

import {useState, useEffect} from 'react';

import {
    fetchGetCustomerCaseData
} from '../../api/pages/customerCaseApi';

import {
    IBanner,
    ICaseTab,
    IVerticalTabText,
    IVideoTextCard,
    ICaseList
} from './types';

// 预请求
let preRequest: any = {
    fetchGetCustomerCaseData: fetchGetCustomerCaseData()
};


const useCustomerCaseHooks = () => {
    const [banner, setBanner] = useState<IBanner>();
    const [enterpriseCase, setEnterpriseCase] = useState<ICaseTab>();
    const [enterpriseCaseIntroduce, setEnterpriseCaseIntroduce] = useState<IVideoTextCard>();
    const [enterpriseCaseCaseSelection, setEnterpriseCaseCaseSelection] = useState<IVerticalTabText>();
    const [caseList, setCaseList] = useState<ICaseList['caseList']>([]);

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetCustomerCaseData || fetchGetCustomerCaseData();
            delete preRequest.fetchGetCustomerCaseData;

            const res = await fetchFunc.catch();
            if (res) {
                const pageData = res.body.result?.pageData || {};
                const ba = pageData.banner || {};
                const baBtns: any[] = Array.isArray(ba.btns) ? ba.btns : [];
                setBanner({
                    title: ba.title,
                    subtitle: ba.subtitle,
                    btns: baBtns.map((btn) => ({
                        title: btn.title,
                        href: btn.href
                    }))
                });

                const ec = pageData.enterpriseCase || {};
                setEnterpriseCase({
                    title: ec.title
                });
                const ecIntroduce = ec.content?.introduce || {};
                setEnterpriseCaseIntroduce({
                    description: ecIntroduce.description,
                    cardTitle: ecIntroduce.cardTitle,
                    videoUrl: ecIntroduce.videoUrl,
                    videoCover: ecIntroduce.videoCover,
                    imgCover: ecIntroduce.imgCover,
                    title: ecIntroduce.title,
                    text: ecIntroduce.text,
                    btnText: ecIntroduce.btnText,
                    btnLink: ecIntroduce.btnLink
                });

                const eccs = ec.content?.caseSelection ?? {};
                const eccsTabs: any[] = Array.isArray(eccs.tabs) ? eccs.tabs : [];
                setEnterpriseCaseCaseSelection({
                    title: eccs.title,
                    tabs: eccsTabs.map((tab) => {
                        const c = tab.content || {};
                        return {
                            title: tab.title,
                            titleIconUrl: tab.titleIconUrl,
                            titleIconSelectedUrl: tab.titleIconSelectedUrl,
                            content: {
                                title: c.title,
                                text: c.text,
                                about: c.about,
                                imageUrl: c.imageUrl,
                                btnText: c.btnText,
                                btnLink: c.btnLink
                            }
                        };
                    })
                });

                pageData.caseList && setCaseList(pageData.caseList);
            }
        })();
    }, []);
    return {
        banner,
        enterpriseCase,
        enterpriseCaseIntroduce,
        enterpriseCaseCaseSelection,
        caseList
    };
};

export default useCustomerCaseHooks;
